// extracted by mini-css-extract-plugin
export default {"methods":"Paychoice_methods__g0ou1"};